
export function createColorPaletteRegistry(colorPalette, options)
{
    const storageKey = options.storageKey ?? "colorRegistry";
   
    const load = () => {
        if (!localStorage) {
            return new Map();
        }

        try {
            const raw = localStorage.getItem(storageKey);
            if (!raw) {
                return new Map();
            }

            const parsed = JSON.parse(raw);

            if (parsed?.entries.length) {
                return new Map(parsed.entries);
            }

            return new Map(parsed ?? {});

        } catch {
            return new Map();
        }
    };

    const save = (map) => {
        if (!localStorage) {
            return new Map();
        }

        try {
            localStorage.setItem(storageKey, JSON.stringify(Array.from(map.entries())));
        } catch {

        }
    };

    const colorRegistry = load();

   return {
    getColorForKey(key) {
        if (!colorRegistry.has(key)) {
            const nextColor = colorPalette[colorRegistry.size % colorPalette.length];
            colorRegistry.set(key, nextColor);
            save(colorRegistry);
        }
        return colorRegistry.get(key);
    },

    getKey(dataset){
        return dataset?.label;
    },

    hasKey(key){
        return colorRegistry.has(key);
    },

    getAllMappings() {
        return Object.fromEntries(colorRegistry);
    },

    seedMappings(m) {
        for (const [k,v] of Object.entries(m)) {
            colorRegistry.set(k, v);
        }
        save(colorRegistry);
    },

    reset() {
        colorRegistry.clear();
        if (localStorage) {
            localStorage.removeItem(storageKey);        }
    }
   };
}